<template>
  <section id="" class="section-scc-portal">
    <div class="container">
      <h1>
        Payment Successful
      </h1>
      <p>We have got your order!</p>
      <p>E-Mail Sent Successfully to {{ recipientEmail }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "rwPaymentSuccessful",
  data(){
    return {
      recipientEmail: '',
    }
  },
  mounted() {
    this.recipientEmail = this.$store.getters["rewards/order"].recipientEmail
  }
}
</script>

<style scoped>

</style>
